
import React from 'react';
import { FormBuilder } from '../../../../../components/form/FormBuilder';
import { reorderMedicationSchema } from '../../../../../shared/static/forms/pharmacy/reorderMedicationForm';
import { MedicationInventory } from '../../../../../interfaces/pharmacy';

interface ReorderMedicationFormProps {
    onSubmit: (data: any) => void;
    initialValues: Partial<MedicationInventory>;
}

export const ReorderMedicationForm: React.FC<ReorderMedicationFormProps> = ({ onSubmit, initialValues }) => {
    return (
        <div className="py-4">
            <FormBuilder
                schema={reorderMedicationSchema as any}
                onSubmit={onSubmit}
                initialValues={initialValues}
                className="space-y-4"
            />
        </div>
    );
} 